import { createActions, createReducer } from 'reduxsauce'
import _ from 'lodash'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: false,
  loaded: false,
  saving: false,
  data: {},
})

const { Types, Creators } = createActions({
  getCartBasedPromotions: null,
  setCartBasedPromotions: ['cartBasedPromotions'],
  setCartBasedPromotion: ['cartBasedPromotionId', 'data'],

  setSaving: ['val'],
  setLoading: ['val'],

  saveCartBasedPromotion: ['data', 'callBack'],
  deleteCartBasedPromotion: ['id'],
})

export const setCartBasedPromotionsReducer = (state, { cartBasedPromotions }) =>
  state.set('data', cartBasedPromotions).set('loaded', true)

export const setCartBasedPromotionReducer = (state, { cartBasedPromotionId, data }) =>
  state.setIn(['data', cartBasedPromotionId], { ...(state.data[cartBasedPromotionId] || {}), ...data })

export const deleteCartBasedPromotionReducer = (state, { id }) => state.set('data', _.omit(state.data, id))

export const setSavingReducer = (state, { val }) => state.set('saving', val)

export const setLoadingReducer = (state, { val }) => state.set('loading', val)

export const cartBasedPromotionReducer = createReducer(INITIAL_STATE, {
  [Types.SET_CART_BASED_PROMOTIONS]: setCartBasedPromotionsReducer,
  [Types.SET_CART_BASED_PROMOTION]: setCartBasedPromotionReducer,

  [Types.SET_LOADING]: setLoadingReducer,
  [Types.SET_SAVING]: setSavingReducer,

  [Types.DELETE_CART_BASED_PROMOTION]: deleteCartBasedPromotionReducer,
})

export const CartBasedPromotionTypes = Types

export default Creators



// WEBPACK FOOTER //
// ./src/reducers/cartBasedPromotionReducer.js